<template>
  <div>
    <v-row>
      <v-col>{{ $t("memberRegistration.step5.content.information") }}</v-col>
    </v-row>
    <v-row>
      <v-col></v-col>
    </v-row>
    <v-col>
      <v-row>
        <v-textarea
          filled
          outlined
          :label="$t('common.feedback')"
          auto-grow
          v-model="feedback"
        ></v-textarea>
      </v-row>
    </v-col>

    <v-row>
      <v-col md="6" sm="6" cols="6" class="text-left">
        <v-btn :color="`${buttonColor}`" class="btn_next" @click="setStep(prevStep)">{{
          $t("registerEvent.prev")
        }}</v-btn>
      </v-col>
      <v-col md="6" sm="6" cols="6" class="text-right">
        <v-btn :color="`${buttonColor}`" class="btn_next" @click="setStep(nextStep)">{{
          $t("registerEvent.next")
        }}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { VRow, VCol, VTextarea, VBtn } from "vuetify/lib";
export default {
  components: {
    VRow,
    VCol,
    VTextarea,
    VBtn,
  },
  props: {
    step: Number,
    buttonColor: String,
    previousStep: Number,
    nextStepValue: Number
  },
  data() {
    return {
      feedback: "",
    };
  },
  computed: 
  {
      prevStep()
      {
        return this.previousStep;
      },
      nextStep()
      {
        return typeof this.nextStepValue === "number" ? this.nextStepValue : this.step + 0.1;
      }
  },
  watch: {
    feedback(val) {
      this.$emit("updateFeedback", val);
    },
  },
  methods: {
    setStep(step) {
      this.$emit("nextStep", step);
    },
  },
};
</script>

<style></style>
